"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPreparePostData = exports.createPrepareFormData = void 0;
/**
 * Prepares form data for editing by removing file URL strings but preserving them for preview
 */
var createPrepareFormData = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.fileFields, fileFields = _a === void 0 ? [] : _a;
    return function (data) {
        if (!data)
            return {};
        var formData = __assign({}, data);
        fileFields.forEach(function (fieldName) {
            if (formData[fieldName] && typeof formData[fieldName] === 'string') {
                formData["".concat(fieldName, "_original_url")] = formData[fieldName];
                delete formData[fieldName];
            }
        });
        return formData;
    };
};
exports.createPrepareFormData = createPrepareFormData;
/**
 * Prepares form data for submission - converts to FormData if files present
 */
var createPreparePostData = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.fileFields, fileFields = _a === void 0 ? [] : _a;
    return function (data) {
        var hasFiles = fileFields.some(function (fieldName) {
            return data[fieldName] &&
                Array.isArray(data[fieldName]) &&
                data[fieldName][0] instanceof File;
        });
        if (hasFiles) {
            var formData_1 = new FormData();
            Object.keys(data).forEach(function (key) {
                if (!fileFields.includes(key) &&
                    data[key] !== null &&
                    data[key] !== undefined) {
                    formData_1.append(key, data[key]);
                }
            });
            fileFields.forEach(function (fieldName) {
                if (data[fieldName] &&
                    Array.isArray(data[fieldName]) &&
                    data[fieldName].length > 0) {
                    var file = data[fieldName][0];
                    if (file instanceof File) {
                        formData_1.append(fieldName, file);
                    }
                }
            });
            return formData_1;
        }
        return data;
    };
};
exports.createPreparePostData = createPreparePostData;
